module.exports = __webpack_public_path__ + "media/images/dashboard-icon-2ca77cd70b99ee2c809385a4eb74ebef.svg";